import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import PricePlanCalculatorInterface from 'common/types/entities/PricePlanCalculatorInterface'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateBaseEntity } from '../utils/generate-base-entity'

export function createPricePlanCalculator(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): PricePlanCalculatorInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.PricePlanCalculator,
      parentId,
      masterBlockId,
    ),
    popupId: null,
  }
}
